import { render } from "./RecommenderChannel.vue?vue&type=template&id=2e13474c&scoped=true"
import script from "./RecommenderChannel.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommenderChannel.vue?vue&type=script&setup=true&lang=js"

import "./RecommenderChannel.vue?vue&type=style&index=0&id=2e13474c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e13474c"],['__file',"src/views/recruitment/recommend/RecommenderChannel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e13474c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e13474c', __exports__)) {
    console.log('reload')
    api.reload('2e13474c', __exports__)
  }
  
  module.hot.accept("./RecommenderChannel.vue?vue&type=template&id=2e13474c&scoped=true", () => {
    console.log('re-render')
    api.rerender('2e13474c', render)
  })

}


export default __exports__